export enum AdditionalOffcanvasDismissReasons {
    X_CLICK = -1
}